document.addEventListener('DOMContentLoaded', function () {

    const cartForms = document.querySelectorAll('.aw-ajax-cart-form');

    cartForms.forEach(form => {

        form.addEventListener('submit', async function (e) {

            e.preventDefault();

            const button = form.querySelector('.aw-cart-btn');

            if (button.classList.contains('loading')) return;

            const defaultState = button.querySelector('.cart-default-state');
            const loadingState = button.querySelector('.cart-loading-state');
            const successState = button.querySelector('.cart-success-state');

            /* START LOADING */

            button.classList.add('loading');

            defaultState.classList.add('d-none');

            successState.classList.add('d-none');

            loadingState.classList.remove('d-none');

            try {

                const formData = new FormData(form);

                const response = await fetch('/cart/add.js', {

                    method: 'POST',

                    body: formData,

                    headers: {
                        'Accept': 'application/json'
                    }

                });

                if (!response.ok) {

                    throw new Error('Cart Error');

                }

                /* SUCCESS */

                loadingState.classList.add('d-none');

                successState.classList.remove('d-none');

                button.classList.add('added');

                /* OPTIONAL CART COUNT UPDATE */

                fetch('/cart.js')
                    .then(res => res.json())
                    .then(cart => {

                        window.awSetCartCount(cart.item_count);

                    });

                /* RESET */

                setTimeout(() => {

                    button.classList.remove('loading');

                    button.classList.remove('added');

                    successState.classList.add('d-none');

                    defaultState.classList.remove('d-none');

                }, 1400);

            } catch (error) {

                console.error(error);

                loadingState.classList.add('d-none');

                defaultState.classList.remove('d-none');

                button.classList.remove('loading');

            }

        });

    });

});
